import { MenuService } from './menu.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LogLevel, LogService } from '@core/logging';
import { environment } from '@env/environment';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class StartupService {
  constructor(
    private http: HttpClient,
    private logService: LogService,
    private menu: MenuService,
    _store: Store
  ) {}

  public async load(): Promise<void> {
    try {
      this.logService.Level = environment.logLevel || LogLevel.All;

      // await coreUtility.requestStateAsync(this.store, coreStore.selectIdentityState, () => identityStore.fetchIdentityAction());

      // this.store.dispatch(identityStore.fetchRolesAction());

      const menuJson: any = await this.http
        .get(`assets/data/menu.json?_t=${Date.now()}`)
        .toPromise();
      this.menu.recursMenuForTranslation(menuJson.menu, 'menu');
      this.menu.set(menuJson.menu);
    } catch (error) {
      this.logService.error('Failed to load startup data.', error);
    }
  }
}
